import { HStack, IconButton, NumberInput } from '@skin-seoul/design-system';
import React from 'react';
import { LucideIcon } from '../../LucideIcon';
const CART_ITEM_QUANTITY_DECREMENT_TRIGGER_TEST_ID = 'cart-item-quantity-decrement-trigger';
const CART_ITEM_QUANTITY_INCREMENT_TRIGGER_TEST_ID = 'cart-item-quantity-increment-trigger';
const CART_ITEM_QUANTITY_INPUT_TEST_ID = 'cart-item-quantity-input';
type CartNumberInputProps = React.ComponentProps<typeof NumberInput.Root>;
const CartNumberInput = ({
  ...props
}: CartNumberInputProps) => {
  return <NumberInput.Root spinOnPress={false} gap={1} step={1} size="xs" {...props} data-sentry-element="NumberInput.Root" data-sentry-component="CartNumberInput" data-sentry-source-file="CartNumberInput.tsx">
      <HStack gap={0} border="1px solid" borderColor="neutral.100" borderRadius="4px" data-sentry-element="HStack" data-sentry-source-file="CartNumberInput.tsx">
        <NumberInput.DecrementTrigger asChild data-testid={CART_ITEM_QUANTITY_DECREMENT_TRIGGER_TEST_ID} data-sentry-element="NumberInput.DecrementTrigger" data-sentry-source-file="CartNumberInput.tsx">
          <IconButton size="2xs" variant="outline" width="24px" height="24px" border="none" _hover={{
          bg: 'transparent'
        }} data-sentry-element="IconButton" data-sentry-source-file="CartNumberInput.tsx">
            <LucideIcon name="Minus" color="neutral.600" data-sentry-element="LucideIcon" data-sentry-source-file="CartNumberInput.tsx" />
          </IconButton>
        </NumberInput.DecrementTrigger>
        <NumberInput.Input data-testid={CART_ITEM_QUANTITY_INPUT_TEST_ID} width="38px" height="24px" textAlign="center" borderY="none" borderX="1px solid" borderColor="neutral.100" borderRadius="0" padding={0} _focus={{
        outline: 'none'
      }} data-sentry-element="NumberInput.Input" data-sentry-source-file="CartNumberInput.tsx" />
        <NumberInput.IncrementTrigger asChild data-testid={CART_ITEM_QUANTITY_INCREMENT_TRIGGER_TEST_ID} data-sentry-element="NumberInput.IncrementTrigger" data-sentry-source-file="CartNumberInput.tsx">
          <IconButton size="2xs" variant="outline" width="24px" height="24px" border="none" _hover={{
          bg: 'transparent'
        }} data-sentry-element="IconButton" data-sentry-source-file="CartNumberInput.tsx">
            <LucideIcon name="Plus" color="neutral.600" data-sentry-element="LucideIcon" data-sentry-source-file="CartNumberInput.tsx" />
          </IconButton>
        </NumberInput.IncrementTrigger>
      </HStack>
    </NumberInput.Root>;
};
export default CartNumberInput;